// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3X-PZ","rootSmall":"AddTileButton_rootSmall__21tvE"};